<header class="topbar">
  <!-- Breadcrumb -->
  <nav class="breadcrumb-nav" aria-label="breadcrumb">
    <img src="assets/icons/house-0E7A7D.svg" alt="" width="13" height="13" class="home-icon">
    @for (crumb of crumbs; track crumb.label; let last = $last) {
      @if (!last) {
        @if (crumb.route) {
          <a class="crumb crumb-link" [routerLink]="crumb.route">{{ crumb.label }}</a>
        } @else {
          <span class="crumb">{{ crumb.label }}</span>
        }
        <span class="crumb-sep">›</span>
      } @else {
        <span class="crumb crumb-current">{{ crumb.label }}</span>
      }
    }
  </nav>

  <!-- Right actions -->
  <div class="topbar-actions">
    <!-- Bell -->
    <button class="action-btn" title="Thông báo">
      <img src="assets/icons/bell-1F2420.svg" alt="Thông báo" width="16" height="16">
    </button>

    <!-- User pill -->
    @if (userData) {
      <div class="user-pill">
        <div class="pill-avatar">
          @if (userData.avatarUrl) {
            <img [src]="userData.avatarUrl" alt="" class="pill-avatar-img">
          } @else {
            <span>{{ (userData.name || userData.email || '?')[0].toUpperCase() }}</span>
          }
        </div>
        <div class="pill-info">
          <span class="pill-name">{{ userData.name || 'Admin' }}</span>
          <span class="pill-role">Quản trị tổng</span>
        </div>
      </div>
    }
  </div>
</header>
